import {SettingsRowValue} from "../../common/CustomTable/CustomTable";
import React from "react";
import {useTranslation} from "react-i18next";
import ThirdPartyUserCredential from "../../../models/thirdparty/ThirdPartyUserCredential";
import ApiKeyUserCredentialFormBody from "../userCredential/ApiKeyUserCredentialFormBody";

function VeritoneUserCredentialFormBody(props) {
    return (
        <ApiKeyUserCredentialFormBody {...props} type={ThirdPartyUserCredential.Type.VERITONE}
            SettingRows={VeritoneUserCredentialFormBodySettingRows}/>
    )
}

function VeritoneUserCredentialFormBodySettingRows(props) {
    const {t} = useTranslation(['thirdPartyService', 'common']);
    const {
        thirdPartyService,
        isDisabled
    } = props;

    return (
        <>
            <SettingsRowValue label={t('thirdPartyService:label.url')} value={thirdPartyService.url}
                isTight isDisabled={isDisabled}/>
        </>
    )
}

export default VeritoneUserCredentialFormBody;
